<template>
  <div>
    <section class="section section-top-padding">
      <form @submit.prevent="validateBeforeSubmit">
        <div class="container" style="padding-top:50px;">
         <div class="columns is-multiline">

          <div class="column is-12" v-if="pageOptions">
            <div class="buttons has-addons">
            <a @click="changePageType(2)" class="button is-small">Thema</a>
            <a @click="changePageType(3)" class="button is-small">Sections</a>
            <a @click="changePageType(4)" class="button is-small">Content</a>
            <a @click="changePageType(5)" class="button is-small">Team</a>
          </div>
          </div>

          <div class="column is-6">

            

            <div class="box card-equal-height"><h2 class="title">SEO<span class="is-pulled-right" style="color:white;" @click="pageOptions=!pageOptions">M</span></h2>

              <!----------- title ---------------------------------->
              <div class="field">
                <label class="label">Meta title (50 Zeichen)* <a href="https://moz.com/learn/seo/title-tag" target="_blank" class="icon"><i class="fa fa-question-circle-o"></i></a></label>
                <div class="control has-icons-right">
                  <input 
                  maxlength="50" 
                  class="input" 
                  type="text" 
                  v-validate="'required'" 
                  :class="{'input': true, 'is-danger': errors.has('title') }" 
                  v-model="n.seo.title" 
                  v-on:keyup="sanitizeTitle"
                  name="title">
                  <span class="icon is-right" v-show="errors.has('title')">
                    <i class="fa fa-warning"></i>
                  </span>
                  <span v-show="errors.has('title')" class="help is-danger">{{ isEmpty }}</span>
                </div>
              </div>

              <!----------- niceUrl ---------------------------------->
              <div class="field">
                <div class="control">
                  <span class="icon"><i class="fa fa-chain"></i></span><span style="color: blue;"><span v-if="pageType==1">/projekte</span><span v-else-if="pageType==2">/themen</span>/{{ n.seo.niceUrl }}</span>
                </div></div>

                <!----------- description ---------------------------------->
                <div class="field">
                  <label class="label">Meta description (50-300 Zeichen) <a href="https://moz.com/learn/seo/meta-description" target="_blank" class="icon"><i class="fa fa-question-circle-o"></i></a></label>
                  <div class="control">
                    <textarea 
                    maxlength="300"  
                    rows="4" 
                    class="textarea"
                    name="description" 
                    v-model="n.seo.description"></textarea>
                  </div>
                </div>

                <!----------- canonical ---------------------------------->
                <div class="field">
                  <label class="label">Canonical tag <a href="https://moz.com/learn/seo/canonicalization" target="_blank" class="icon"><i class="fa fa-question-circle-o"></i></a></label>
                  <div class="control has-icons-right">
                   <input
                   class="input"
                   v-model="n.seo.can"
                   name="canonical" 
                   v-validate="'url:require_protocol'"
                   placeholder="URL mit https://">
                   <span class="icon is-right" v-show="errors.has('canonical')"><i class="fa fa-warning"></i></span><span v-show="errors.has('canonical')" class="help is-danger">URL ungültig</span>
                 </div>
               </div>
             </div>
           </div>

           <div class="column is-6">
            <!----------- SERP Preview ---------------------------------->
            <div class="box">
              <div style="text-decoration: none; color: #1a0dab; font-size: 21px; font-family: arial,sans-serif; height: 35px; overflow: hidden;"><span v-if="n.seo.title">{{ n.seo.title }} - Planung. Beratung. Forschung.</span><span v-else>Google SERP Preview: Geben Sie einen Meta Title an</span></div>

              <div style="color: #006621; font-size: 16px; font-family: arial,sans-serif; line-height: 16px; height: 22px; overflow: hidden;"><span v-if="n.seo.niceUrl">{{ n.seo.niceUrl }}</span><span v-else>www.jauschneg.at</span></div>

              <div style="font-family: arial,sans-serif; line-height: 18px; font-size: 16px; max-height: 54px; overflow: hidden;"><span v-if="n.seo.description">{{ n.seo.description }}</span><span v-else>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugiat quibusdam, eos eveniet, earum itaque eius, ipsum voluptas, voluptates similique rem nobis dolor.</span></div>
            </div>

            <!----------- imagepreview ---------------------------------->
            <div class="box">
              <div class="columns">
                <div class="column is-12">
                  <strong>Übersichtsfoto (mind. 450 x 250 px)*</strong>

                  <a class="icon is-info is-large is-pulled-right" @click="showImageSelector('imagePreview')" v-if="!n.seo.image.path.length">
                    <i class="fa fa-plus-circle fa-2x"></i>
                  </a>

                </div>
              </div>

              <div class="columns is-multiline" v-if="n.seo.image.path.length">
                <div class="column is-12">

                  <div class="card card-equal-height">
                    <div class="card-image">
                      <figure class="image">
                        <img :src="assetsBaseUrl + n.seo.image.path">
                      </figure>
                    </div>
                    <div class="card-content">
                      <div class="content">
                        <input type="text" class="input" placeholder="Beschreibung / Fotonachweis" v-model="n.seo.image.credits">
                      </div>
                    </div>
                    <footer class="card-footer">
                      <a class="card-footer-item" @click="n.seo.image={ path: '', credits: '' }">Löschen</a>
                    </footer>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <app-headline v-if="n.hasOwnProperty('headline')"
          :elLabel="'Überschrift*'" 
          :data="n.headline" 
          :isEmpty="isEmpty"
          @wasUpdated="n.headline=$event"
          ></app-headline>

          <app-subtitle v-if="n.hasOwnProperty('subtitle')"
          :elLabel="'Untertitel'" 
          :data="n.subtitle" 
          @wasUpdated="n.subtitle=$event"
          ></app-subtitle>

          <app-tags v-if="n.hasOwnProperty('tags')"
          :elLabel="pageType === 1 ? 'Tags' : 'Projekte folgender Themen anzeigen'" 
          :data="n.tags" 
          :allTags="allTags" 
          @wasUpdated="filterContentBy($event)"
          ></app-tags>

          <app-team v-if="n.hasOwnProperty('team')"
          :elLabel="'Team'" 
          :data="n.team" 
          :propName="'team'"
          @teamWasAdded="addTeam"
          @teamWasRemoved="removeTeam($event)"
          @removeImage="removeTeamImg($event)"
          @removeDownload="removeTeamDownload($event)"
          @showImageSelector="showImageSelector($event)"
          @wasSorted="n.team = $event"
          ></app-team>

          <app-HTML v-if="n.hasOwnProperty('text')"
          :elLabel="''" 
          :data="n.text" 
          @wasUpdated="n.text=$event"
          ></app-HTML>

          <app-markdown v-if="n.hasOwnProperty('sidebar')"
          :elLabel="'Sidebar Text'" 
          :data="n.sidebar" 
          @wasUpdated="n.sidebar=$event"
          ></app-markdown>

          <app-videos v-if="n.hasOwnProperty('videos')"
          :elLabel="'YouTube Videos'" 
          :data="n.videos" 
          @videoWasDeleted="deleteVideo($event)"
          @videoWasAdded="addVideo($event)"
          @wasSorted="n.videos = $event"
          ></app-videos>

          <app-links v-if="n.hasOwnProperty('links')"
          :elLabel="'Links'" 
          :data="n.links" 
          @linkWasDeleted="deleteLink($event)"
          @linkWasAdded="addLink($event)"
          @wasSorted="n.links = $event"
          ></app-links>

          <app-downloads v-if="n.hasOwnProperty('downloads')"
          :elLabel="'Downloads'" 
          :data="n.downloads" 
          :isImage="isImage"
          @downloadWasDeleted="deleteDownload($event)"
          @showImageSelector="showImageSelector($event)"
          @wasSorted="n.downloads = $event"
          ></app-downloads>

          <app-images v-if="n.hasOwnProperty('images')"
          :elLabel="'Fotos Slider'" 
          :data="n.images" 
          :propName="'images'"
          @imageWasDeleted="deleteImg($event)"
          @showImageSelector="showImageSelector($event)"
          @wasSorted="n.images = $event"
          ></app-images>

          <app-images v-if="n.hasOwnProperty('masonry')"
          :elLabel="'Fotos'" 
          :data="n.masonry" 
          :propName="'masonry'"
          @imageWasDeleted="deleteImg($event)"
          @showImageSelector="showImageSelector($event)"
          ></app-images>

          <app-images v-if="n.hasOwnProperty('thumbnail')"
          :elLabel="'Quadratische Voransichtsbild'" 
          :data="n.thumbnail" 
          :propName="'thumbnail'"
          @imageWasDeleted="deleteImg($event)"
          @showImageSelector="showImageSelector($event)"
          ></app-images>

          <app-sections v-if="n.hasOwnProperty('sections')"
          :elLabel="'Sections'" 
          :data="n.sections" 
          :propName="'sections'"
          @sectionWasAdded="addSection"
          @sectionWasRemoved="removeSection($event)"
          @removeImage="removeColImg($event)"
          @columnWasRemoved="removeColumn($event)"
          @showImageSelector="showImageSelector($event)"
          @fullwidthChanged="changeFullwidth($event)"
          @columnWasAdded="addColumn($event)"
          @wasSorted="n.sections = $event"
          ></app-sections>

          <!-- image selector modal -->
          <div class="modal is-active" v-if="imgSelector">
            <div class="modal-background" @click="imgSelector=!imgSelector"></div>
            <div class="modal-card card-margin">
              <header class="modal-card-head">
                <p class="modal-card-title">Bilder wählen</p>
                <a class="delete" aria-label="close" @click="imgSelector=!imgSelector"></a>
              </header>
              <section class="modal-card-body">

                <div class="columns is-multiline">
                  <div class="column is-12">

                    <div class="select is-fullwidth">
                      <select @change="getS3Files($event.target.value)">
                        <option value="root">/</option>
                        <option v-for="(i, index) in S3folders" :key="index" :value="i">{{ i }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="column is-12">

                    <table class="table is-bordered is-hoverable is-striped is-narrow is-fullwidth">
                      <thead>
                        <tr>
                          <th>Dateiname
                            <a class="icon is-pulled-right" @click="showList=true"><i class="fa fa-reorder"></i></a>
                            <a class="icon is-pulled-right" @click="showList=false"><i class="fa fa-th-large"></i></a>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="showList" v-for="(i, index) in S3files" :key="index">
                          <td><a @click="addImage(i, target)">{{ i }}</a></td>
                        </tr>

                        <tr v-if="!showList">
                          <td><div class="columns is-variable is-multiline is-1 is-mobile" v-masonry transition-duration="0.3s" item-selector=".bilder">
                            <div v-masonry-tile class="column is-3 bilder break-word" v-for="(i, index) in S3files" :key="index">
                              <a @click="addImage(i, target)"><img :src="assetsBaseUrl + i" v-if="isImage(i)"><img src="../../assets/file.png" v-else></a><br><span class="is-size-7">{{ i }}</span>
                            </div>
                          </div></td>
                        </tr>
                        <tr v-if="!S3files.length">
                          <td>Dieser Ordner ist leer</td>
                        </tr>
                      </tbody>
                    </table>

                  </div>
                </div>

              </section>
              <footer class="modal-card-foot">
                <a class="button" @click="imgSelector=!imgSelector">Abbrechen</a>
              </footer>
            </div>
          </div>

          <div class="column is-12">
            <div class="box" v-if="n.hasOwnProperty('pageSlider')">

              <div class="column is-12">
              <strong>Page Slider Elemente</strong>
            </div>

              <div class="column is-12">

              <div class="control" v-for="(i, index) in content" :key="index">
                  <input class="is-checkradio is-circle" :id="'pageSlide' + index" type="checkbox" @click="pageSlider(i.id)" :checked="n.pageSlider.indexOf(i.id) !== -1">
                  <label :for="'pageSlide' + index">{{ i.content.seo.title }}</label>
              </div>

            </div>

              <div class="column is-12">
              Deaktivieren Sie alle Seiten um das statische Übersichtsfoto anstelle des Page Sliders anzuzeigen
            </div>

            </div>
            <div class="box" v-else><a @click="activatePageSlider">Page Slider aktivieren</a></div>
          </div>

          <div class="column is-12 has-text-centered">
            <input type="submit" :value="n.seo.image.path.length ? 'Speichern' : 'Fehler (Übersichtsfoto fehlt)'" class="button is-large is-primary is-fullwidth" :disabled="!n.seo.image.path.length">
          </div>

        </div>
      </div>
    </form>
  </section>
</div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import draggable from 'vuedraggable'
import Videos from '@/components/cms/elements/Videos'
import Links from '@/components/cms/elements/Links'
import Headline from '@/components/cms/elements/Headline'
import Tags from '@/components/cms/elements/Tags'
import HTML from '@/components/cms/elements/HTML'
import Subtitle from '@/components/cms/elements/Subtitle'
import Markdown from '@/components/cms/elements/Markdown'
import Downloads from '@/components/cms/elements/Downloads'
import Images from '@/components/cms/elements/Images'
import Sections from '@/components/cms/elements/Sections'
import Team from '@/components/cms/elements/Team'

export default {
  props: ['id'],
  data () {
    return {
      pageOptions: false,
      pageType: 1, // default: PROJECT
      showList: true,
      S3folders: [],
      S3files: [],
      editMode: false,
      target: 'images',
      imgSelector: false,
      downloads: { caption: '', url: '' },
      center: { lng: 15.5, lat: 48.5 },
      confirmed: false,
      isEmpty: 'Benötigtes Feld',
      n: {
        seo: {
          can: '',
          image: { path: '', credits: '' },
          niceUrl: '',
          description: '',
          title: '',
          ogType: 'article'
        },
        headline: '',
        subtitle: '',
        text: '',
        sidebar: '',
        links: [],
        downloads: [],
        images: [],
        masonry: [],
        videos: [],
        tags: [],
        pageSlider: [],
        thumbnail: []
      }
    }
  },
  metaInfo: {
    meta: [
      { name: 'robots', content: 'NOINDEX, NOFOLLOW' }
    ]
  },
  methods: {
    activatePageSlider () {
      Vue.set(this.n, 'pageSlider', [])
    },
    pageSlider (v) {
      var i = this.n.pageSlider.indexOf(v)
      if (i === -1) {
        this.n.pageSlider.push(v)
      } else {
        this.n.pageSlider.splice(i, 1)
      }
    },
    changePageType (v) {
      if (v === 2) { // THEMA
        this.pageType = 2
        Vue.delete(this.n, 'sidebar')
        Vue.delete(this.n, 'links')
        Vue.delete(this.n, 'downloads')
        Vue.delete(this.n, 'thumbnail')
      } else if (v === 3) { // SECTIONS
        this.pageType = 3
        Vue.set(this.n, 'sections', [])
        Vue.delete(this.n, 'headline')
        Vue.delete(this.n, 'subtitle')
        Vue.delete(this.n, 'text')
        Vue.delete(this.n, 'sidebar')
        Vue.delete(this.n, 'links')
        Vue.delete(this.n, 'downloads')
        Vue.delete(this.n, 'images')
        Vue.delete(this.n, 'videos')
        Vue.delete(this.n, 'tags')
        Vue.delete(this.n, 'thumbnail')
        Vue.delete(this.n, 'masonry')
      } else if (v === 4) { // CONTENT
        this.pageType = 4
        Vue.delete(this.n, 'sidebar')
        Vue.delete(this.n, 'links')
        Vue.delete(this.n, 'downloads')
        Vue.delete(this.n, 'images')
        Vue.delete(this.n, 'videos')
        Vue.delete(this.n, 'tags')
        Vue.delete(this.n, 'thumbnail')
        Vue.delete(this.n, 'masonry')
      } else if (v === 5) { // Team
        this.pageType = 5
        Vue.set(this.n, 'team', [])
        Vue.delete(this.n, 'sidebar')
        Vue.delete(this.n, 'links')
        Vue.delete(this.n, 'downloads')
        Vue.delete(this.n, 'images')
        Vue.delete(this.n, 'videos')
        Vue.delete(this.n, 'tags')
        Vue.delete(this.n, 'thumbnail')
        Vue.delete(this.n, 'masonry')
      }
    },
    getS3Files (v) {
      const vm = this
      axios.get('/files/' + v)
        .then(function (res) {
          vm.S3files = res.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getS3Folders () {
      const vm = this
      axios.get('/folders')
        .then(function (res) {
          vm.S3folders = res.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    isImage (file) {
      if (file.split('.').pop() === 'png' || file.split('.').pop() === 'jpg' || file.split('.').pop() === 'gif' || file.split('.').pop() === 'jpeg' || file.split('.').pop() === 'JPEG' || file.split('.').pop() === 'JPG') {
        return true
      }
    },
    // validation, check if edit mode is on, if new: check if niceUrl already exists, create or update
    validateBeforeSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (!this.editMode) {
            const vm = this
            axios.post('/content/checkUrl', this.n.seo)
              .then(function (response) {
                if (response.data === true) {
                  alert('Dieser Meta Title und URL sind schon in Verwendung!')
                } else {
                  axios.post('/content', {
                    content: vm.n
                  })
                    .then(function (response) {
                      vm.confirmed = true
                      vm.$router.push('/cms/list')
                    })
                    .catch(function (error) {
                      alert('Es ist leider ein Fehler aufgetreten!')
                      console.log(error)
                    })
                }
              })
              .catch(function (error) {
                alert('Es ist leider ein Fehler aufgetreten!')
                console.log(error)
              })
            return
          } else if (this.editMode && this.$route.query.new) {
            const vm = this
            const lang = vm.$route.query.lang
            axios.post('/content/checkUrl', this.n.seo)
              .then(function (response) {
                if (response.data === true) {
                  alert('Dieser Meta Title und URL sind schon in Verwendung!')
                } else {
                  axios.put('/content/' + vm.id, {
                    lang: lang,
                    content: vm.n
                  })
                    .then(function (response) {
                      vm.confirmed = true
                      vm.$router.push('/cms/list')
                    })
                    .catch(function (error) {
                      alert('Es ist leider ein Fehler aufgetreten!')
                      console.log(error)
                    })
                }
              })
              .catch(function (error) {
                alert('Es ist leider ein Fehler aufgetreten!')
                console.log(error)
              })
            return
          } else {
            const vm = this
            const lang = vm.$route.query.lang
            axios.put('/content/' + this.id, {
              lang: lang,
              content: vm.n
            })
              .then(function (response) {
                vm.confirmed = true
                vm.$router.push('/cms/list')
              })
              .catch(function (error) {
                alert('Es ist leider ein Fehler aufgetreten!')
                console.log(error)
              })
            return
          }
        }
        alert('Bitte füllen Sie alle benötigten Felder aus!')
      })
    },
    showImageSelector (target) {
      this.imgSelector = true
      this.target = target
      if (!this.S3files.length) {
        this.getS3Files('root')
        this.getS3Folders()
      }
    },
    addColumn (v) {
      this.n.sections[v].columns.push({ image: { path: '' }, headline: '', text: '', link: '', linkExternal: false })
    },
    changeFullwidth (v) {
      Vue.set(this.n.sections[v], 'fullwidth', !this.n.sections[v].fullwidth)
    },
    removeColImg (v) {
      Vue.set(this.n.sections[v.parent].columns[v.child].image, 'path', '')
    },
    removeTeamImg (v) {
      Vue.set(this.n.team[v.child], 'image', '')
    },
    removeTeamDownload (v) {
      Vue.set(this.n.team[v.child], 'download', '')
    },
    addSection () {
      this.n.sections.push({
        id: Date.now(),
        fullwidth: false,
        style: 'is-white',
        size: 'auto',
        headline: '',
        subtitle: '',
        columns: [
          { image: { path: '' }, headline: '', text: '', link: '', linktext: '', linkExternal: false }
        ]
      })
    },
    addTeam () {
      this.n.team.push({
        text: '',
        image: '',
        download: '',
        name: '',
        title: '',
        social: { globe: '', linkedin: '', xing: '', twitter: '', facebook: '', google: '', instagram: '', youtube: '', envelope: '' }
      })
    },
    deleteVideo (v) {
      this.n.videos.splice(v, 1)
    },
    removeSection (v) {
      if (confirm('Sind Sie sich sicher?') === true) {
        this.n.sections.splice(v, 1)
      }
    },
    removeTeam (v) {
      if (confirm('Sind Sie sich sicher?') === true) {
        this.n.team.splice(v, 1)
      }
    },
    removeColumn (v) {
      if (confirm('Sind Sie sich sicher?') === true) {
        this.n.sections[v.section].columns.splice(v.column, 1)
      }
    },
    addVideo (v) {
      this.n.videos.push(v)
    },
    addImage (path, target) {
      if (target === 'downloads') {
        const img = { url: path, caption: '' }
        this.n.downloads.push(img)
      } else if (target === 'imagePreview') {
        if (this.isImage(path)) {
          this.n.seo.image.path = path
        } else {
          alert('Es können nur Fotos ausgewählt werden')
        }
      } else if (target.target === 'sections') {
        if (this.isImage(path)) {
          Vue.set(this.n.sections[target.parent].columns[target.child].image, 'path', path)
        } else {
          alert('Es können nur Fotos ausgewählt werden')
        }
      } else if (target.target === 'team') {
        if (this.isImage(path)) {
          Vue.set(this.n.team[target.child], 'image', path)
        } else {
          alert('Es können nur Fotos ausgewählt werden')
        }
      } else if (target.target === 'download') {
        Vue.set(this.n.team[target.child], 'download', path)
      } else {
        if (this.isImage(path)) {
          const img = { path: path, caption: '', credits: '' }
          this.n[target].push(img)
        } else {
          alert('Es können nur Fotos ausgewählt werden')
        }
      }
      this.imgSelector = false
    },
    deleteLink (v) {
      this.n.links.splice(v, 1)
    },
    deleteDownload (v) {
      this.n.downloads.splice(v, 1)
    },
    deleteImg (v) {
      this.n[v.prop].splice(v.i, 1)
    },
    addLink (v) {
      this.n.links.push(v)
    },
    addDownload () {
      if (this.downloads.url.length && !this.$validator.errors.has('downloadurl') && !this.$validator.errors.has('downloadcaption')) {
        this.n.downloads.push(this.downloads)
        this.downloads = { caption: '', url: '' }
      }
    },
    filterContentBy (v) {
      var i = this.n.tags.indexOf(v)
      if (i === -1) {
        this.n.tags.push(v)
      } else {
        this.n.tags.splice(i, 1)
      }
    },
    sanitizeTitle () {
      if ((this.editMode && this.$route.query.new) || (!this.editMode)) {
        var slug = this.n.seo.title
        slug = slug.toLowerCase()
        // Umlaut ä
        slug = slug.replace(/ä/gi, 'ae')
        // Umlaut ö
        slug = slug.replace(/ö/gi, 'oe')
        // Umlaut ü
        slug = slug.replace(/ü/gi, 'ue')
        // ß
        slug = slug.replace(/ß/gi, 'ss')
        // Trim the last whitespace
        slug = slug.replace(/\s*$/g, '')
        // Change whitespace to "-"
        slug = slug.replace(/\s+/g, '-')
        // special characters
        slug = slug.replace(/[^a-zA-Z0-9-]/g, '')
        this.n.seo.niceUrl = slug
      }
    }
  },
  computed: {
    allTags () {
      return this.$store.getters.allTags
    },
    assetsBaseUrl () {
      return this.$store.getters.assetsBaseUrl
    },
    content () {
      return this.$store.getters.content // Alle Seiten
    },
    currentSlug () {
      if (this.pageType === 1) {
        return '/projekte/'
      } else if (this.pageType === 2) {
        return '/themen/'
      } else {
        return '/'
      }
    }
  },
  created () {
    console.log(this.assetsBaseUrl)
    // if edit mode is on, fetch and replace n with the corresponding object
    if (this.$route.name === 'edit') {
      this.editMode = true
      const vm = this
      axios.get('/content/single/' + this.id)
        .then(function (res) {
          if (vm.$route.query.lang === 'de') {
            vm.n = res.data.de_content
          } else if (vm.$route.query.lang === 'en') {
            vm.n = res.data.en_content
          }
          if (vm.$route.query.new) {
            vm.n = res.data.de_content
            alert('Um das Übersetzen zu vereinfachen wird eine Kopie der deutschen Seite angelegt')
          }
          vm.pageType = res.data.type
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  components: {
    draggable,
    appVideos: Videos,
    appLinks: Links,
    appHeadline: Headline,
    appSubtitle: Subtitle,
    appTags: Tags,
    appHTML: HTML,
    appMarkdown: Markdown,
    appDownloads: Downloads,
    appImages: Images,
    appSections: Sections,
    appTeam: Team
  },
  beforeRouteLeave (to, from, next) {
    if (this.confirmed) {
      next()
    } else {
      if (confirm('Der Datensatz wurde noch nicht gespeichert. Wollen Sie die Seite wirklich verlassen?')) {
        next()
      } else {
        next(false)
      }
    }
  }
}
</script>

<style scoped>
.card-content {padding:0;}
.bilder {width: 28%; height: auto;margin:6px;}
</style>



// WEBPACK FOOTER //
// src/components/cms/Create.vue